<template>
    <div class="run-monitor-container">
        <div class="uxbox">
            <ul style="height: 100%">
                <li class="ubx1">
                    <div class="lfdiv">
                        <h2 class="nyh2">{{ $t('windPowerGenerationMonitoring.installedCapacity') }}</h2>
                        <v-chart
                            :auto-resize="true"
                            :options="puloxPie"
                            ref="puloxPie"
                            theme="ovilia-green"
                        />
                    </div>
                    <div class="ub_right">
                        <p>
                            <span>
                                <!-- <span class="grey">photovoltaic容量：</span> -->
                                <span class="grey">{{ $t('windPowerGenerationMonitoring.pvCapacity') }}:</span>
                                <i>3481.82</i>kW
                            </span>
                        </p>
                        <p style="color: #aaa">
                            <span>
                                <!-- <span class="grey">风机容量：</span> -->
                                <span class="grey">{{ $t('windPowerGenerationMonitoring.dailyTCEReduction') }}:</span>
                                <i>1000</i>kW
                            </span>
                        </p>
                    </div>
                    <!-- <div class="ub_right">
                        <p style="margin-left: 0.5rem">
                            <span>
                                <i style="font-size: 2.5rem">12.3</i>kW
                            </span>
                        </p>
                        <p style="margin: 0 0 0 1.5rem">
                            <span class="grey" style="font-size: 1.3rem"
                                >总容量</span
                            >
                        </p>
                    </div> -->
                </li>
                <li class="ubx2">
                    <div class="lfdiv">
                        <!-- <h2 class="nyh2">日GENERATING ELECTRICITY</h2> -->
                        <h2 class="nyh2">{{ $t('windPowerGenerationMonitoring.dailyPowerGeneration') }}</h2>
                        <v-chart
                            :auto-resize="true"
                            :options="puloxPieDay"
                            ref="puloxPieDay"
                            theme="ovilia-green"
                        />
                    </div>
                    <div class="ub_right">
                        <p>
                            <span>
                                <!-- <span class="grey">日节约标煤：</span> -->
                                <span class="grey">{{ $t('windPowerGenerationMonitoring.dailyPowerGeneration') }}:</span>
                                <i>1.95</i>
                            </span>
                        </p>
                        <p style="color: #aaa">
                            <span>
                                <!-- <span class="grey">日减排co2：</span> -->
                                <span class="grey">{{ $t('windPowerGenerationMonitoring.dailyCO2Reduction') }}:</span>
                                <i>8.37</i>ton
                            </span>
                        </p>
                    </div>
                </li>
                <li class="ubx3">
                    <div class="lfdiv">
                        <!-- <h2 class="nyh2">月GENERATING ELECTRICITY</h2> -->
                        <h2 class="nyh2">{{ $t('windPowerGenerationMonitoring.monthlyPowerGeneration') }}</h2>
                        <v-chart
                            :auto-resize="true"
                            :options="puloxPieMonths"
                            ref="puloxPieMonths"
                            theme="ovilia-green"
                        />
                    </div>
                    <div class="ub_right">
                        <p>
                            <span>
                                <!-- <span class="grey">月节约标煤：</span> -->
                                <span class="grey">{{ $t('windPowerGenerationMonitoring.monthlyTCEReduction') }}:</span>
                                <i>35.66</i>
                            </span>
                        </p>
                        <p style="color: #aaa">
                            <span>
                                <!-- <span class="grey">月减排co2：</span> -->
                                <span class="grey">{{ $t('windPowerGenerationMonitoring.monthlyCO2Reduction') }}:</span>
                                <i>152.94</i>ton
                            </span>
                        </p>
                    </div>
                </li>
                <li class="ubx4">
                    <div class="lfdiv">
                        <!-- <h2 class="nyh2">年GENERATING ELECTRICITY</h2> -->
                        <h2 class="nyh2">{{ $t('windPowerGenerationMonitoring.annualPowerGeneration') }}</h2>
                        <v-chart
                            :auto-resize="true"
                            :options="puloxPieYear"
                            ref="puloxPieYear"
                            theme="ovilia-green"
                        />
                    </div>
                    <div class="ub_right">
                        <p>
                            <span>
                                <span class="grey">{{ $t('windPowerGenerationMonitoring.annualTCEReduction') }}：</span>
                                <i>56.91</i>
                            </span>
                        </p>
                        <p style="color: #aaa">
                            <span
                                ><span class="grey">{{ $t('windPowerGenerationMonitoring.annualCO2Reduction') }}n：</span
                                ><i>244.1</i>ton
                            </span>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="nenghao">
            <div class="boxbox">
                <h2 class="nyh2">{{ $t('windPowerGenerationMonitoring.microgridRTPowerGeneration') }}</h2>
                <div class="tab_cssl1" id="tas1_content">
                    <v-chart
                        :auto-resize="true"
                        :options="energyBar"
                        ref="energyBar"
                        theme="ovilia-green"
                    />
                </div>
            </div>
        </div>
        <div class="goucheng">
            <div class="tab_cssv" id="tav1_content">
                <div class="fl gou1">
                    <h2 class="nyh2">{{ $t('windPowerGenerationMonitoring.totalGeneratedElectricity') }}</h2>
                    <v-chart
                        :auto-resize="true"
                        :options="elecConstruct"
                        ref="elecConstruct"
                        theme="ovilia-green"
                        @click="clickYearBar"
                    />
                </div>
                <div class="fr gou1">
                    <h2 class="nyh2">{{ $t('windPowerGenerationMonitoring.microgridTDComparison') }}</h2>
                    <v-chart
                        :auto-resize="true"
                        :options="elecHour"
                        ref="elecHour"
                        theme="ovilia-green"
                        @click="clickYearBar"
                    />
                </div>
                <div style="clear: both"></div>
            </div>
            <!-- <div class="tab_cssv" id="tav1_content">1212</div> -->
        </div>
    </div>
</template>
<script>
// import echarts from "echarts";
import "echarts/map/js/china.js";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
export default {
    name: "Main",
    components: {},
    data() {
        return {
            pieInnerFont: 11, //饼状图内部数字字体大小
            pieInnerTtitleFont: 10, //饼状图内部文字字体大小
            legendFont: 11, // 图例文字大小
            timer: ""
        };
    },
    watch: {},
    mounted() {
        this.setImgSize();
        window.onresize = () => {
            this.setImgSize();
        };
        // this.timer = setInterval(this.reloadData, 5000);
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
        routerGo(url) {
            this.$router.push(url);
        },
        reloadData() {
            console.log("loading data...........");
        },
        setImgSize() {
            // if (window.innerWidth >= 1920) {
            //     this.pieInnerFont = 13;
            //     this.pieInnerFontUnit = 10;
            //     this.pieInnerTtitleFont = 15;
            //     this.legendFont = 12;
            // } else if (window.innerWidth < 1920 && window.innerWidth >= 1660) {
            //     this.pieInnerFont = 14;
            //     this.pieInnerFontUnit = 11;
            //     this.pieInnerTtitleFont = 13;
            //     this.legendFont = 12;
            // } else if (window.innerWidth < 1660 && window.innerWidth >= 1420) {
            //     this.pieInnerFont = 13;
            //     this.pieInnerFontUnit = 10;
            //     this.pieInnerTtitleFont = 11;
            //     this.legendFont = 10;
            // } else {
            //     this.pieInnerFont = 12;
            //     this.pieInnerFontUnit = 10;
            //     this.pieInnerTtitleFont = 10;
            //     this.legendFont = 10;
            // }
        }
    },
    computed: {
        elecConstruct() {
            const options = {
                grid: {
                    left: "3%",
                    right: "3%",
                    bottom: "10%",
                    top: "20%",
                    containLabel: true
                },
                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    orient: "horizontal",
                    icon: "circle",
                    // top: 10,
                    data: [
                        {
                            name: this.$t('windPowerGenerationMonitoring.fdfdl'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        // {
                        //     name: "photovoltaicGENERATING ELECTRICITY",
                        //     textStyle: {
                        //         color: "#fff",
                        //         fontSize: this.legendFont
                        //     }
                        // }
                    ]
                },
                color: ["#0091e9", "#fe7f65"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "",
                        data: [
                            "2020-11-1",
                            "2020-11-2",
                            "2020-11-3",
                            "2020-11-4",
                            "2020-11-5",
                            "2020-11-6",
                            "2020-11-7",
                            "2020-11-8",
                            "2020-11-9",
                            "2020-11-10",
                            "2020-11-11",
                            "2020-11-12",
                            "2020-11-13",
                            "2020-11-14",
                            "2020-11-15"
                        ],
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#046DDA" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        //name: "单位: kWh",
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#046DDA" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#046DDA" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: this.$t('windPowerGenerationMonitoring.fdfdl'),
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: [
                            20,
                            10,
                            80,
                            35,
                            65,
                            34,
                            12,
                            65,
                            87,
                            43,
                            31,
                            65,
                            87,
                            43,
                            32
                        ]
                    },
                    // {
                    //     name: "photovoltaicGENERATING ELECTRICITY",
                    //     type: "bar",
                    //     stack: "one",
                    //     barWidth: "50%",
                    //     data: [
                    //         54,
                    //         32,
                    //         32,
                    //         54,
                    //         76,
                    //         87,
                    //         98,
                    //         65,
                    //         54,
                    //         32,
                    //         11,
                    //         23,
                    //         65,
                    //         87,
                    //         98
                    //     ]
                    // }
                ]
            };
            return options;
        },
        elecHour() {
            const options = {
                grid: {
                    left: "3%",
                    right: "3%",
                    bottom: "10%",
                    top: "20%",
                    containLabel: true
                },
                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    orient: "horizontal",
                    icon: "circle",
                    data: [
                        {
                            name: this.$t('windPowerGenerationMonitoring.fsfdl'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: this.$t('windPowerGenerationMonitoring.gsfdl'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: this.$t('windPowerGenerationMonitoring.psfdl'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        }
                    ]
                },
                color: ["#0091e9", "#4EC261", "#fe7f65"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "",
                        data: [
                            "2020-11-1",
                            "2020-11-2",
                            "2020-11-3",
                            "2020-11-4",
                            "2020-11-5",
                            "2020-11-6",
                            "2020-11-7",
                            "2020-11-8",
                            "2020-11-9",
                            "2020-11-10",
                            "2020-11-11",
                            "2020-11-12",
                            "2020-11-13",
                            "2020-11-14",
                            "2020-11-15"
                        ],
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#046DDA" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        //  name: "单位: kWh",
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#046DDA" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#046DDA" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: this.$t('windPowerGenerationMonitoring.fsfdl'),
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: [
                            20,
                            10,
                            80,
                            35,
                            65,
                            34,
                            12,
                            65,
                            87,
                            43,
                            31,
                            65,
                            87,
                            43,
                            32
                        ]
                    },
                    {
                        name: this.$t('windPowerGenerationMonitoring.gsfdl'),
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: [
                            54,
                            32,
                            32,
                            54,
                            76,
                            87,
                            98,
                            65,
                            54,
                            32,
                            11,
                            23,
                            65,
                            87,
                            98
                        ]
                    },
                    {
                        name: this.$t('windPowerGenerationMonitoring.psfdl'),
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: [
                            54,
                            76,
                            54,
                            32,
                            15,
                            76,
                            32,
                            13,
                            23,
                            43,
                            65,
                            87,
                            43,
                            32,
                            54
                        ]
                    }
                ]
            };
            return options;
        },
        energyBar() {
            const option = {
                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                grid: {
                    left: "4%",
                    right: "1%",
                    bottom: "10%",
                    top: "10%",
                    containLabel: true
                },
                color: ["#00FFFE", "#FD980a"],
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#046DDA" // 颜色
                        }
                    },
                    data: [
                        "00:15",
                        "00:30",
                        "00:45",
                        "1:00",
                        "1:15",
                        "1:30",
                        "1:45",
                        "2:00",
                        "2:15",
                        "2:30",
                        "2:45",
                        "3:00",
                        "3:15",
                        "3:30",
                        "3:45"
                    ]
                },
                yAxis: {
                    type: "value",
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#046DDA" // 颜色
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#046DDA" // 颜色
                        }
                    }
                },
                series: [
                    // {
                    //     name: "photovoltaic发电功率",
                    //     type: "line",
                    //     data: [
                    //         8,
                    //         10,
                    //         1,
                    //         15,
                    //         7,
                    //         12,
                    //         11,
                    //         4,
                    //         15,
                    //         5,
                    //         17,
                    //         2,
                    //         16,
                    //         4,
                    //         18
                    //     ]
                    // },
                    {
                        name: this.$t('windPowerGenerationMonitoring.fdfdgl'),
                        type: "line",
                        data: [
                            18,
                            6,
                            16,
                            4,
                            17,
                            9,
                            2,
                            14,
                            5,
                            15,
                            1,
                            16,
                            4,
                            20,
                            3,
                            13
                        ]
                    }
                ]
            };
            return option;
        },
        puloxPie() {
            const option = {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                // title: {
                //     text: "total capacity",
                //     left: "center",
                //     top: "45%",
                //     textStyle: {
                //         color: "#A6AFB8",
                //         fontSize: this.pieInnerTtitleFont,
                //         align: "center"
                //     }
                // },
                graphic: [
                    {
                        type: "text",
                        left: "center",
                        top: "30%",
                        style: {
                            text: "4481.82kW",
                            textAlign: "center",
                            fill: "#FD980a",
                            width: 30,
                            height: 30,
                            fontSize: this.pieInnerFont,
                            fontFamily: "Microsoft YaHei"
                        }
                    },
                    {
                        type: "text",
                        left: "center",
                        top: "43%",
                        style: {
                            text: this.$t('windPowerGenerationMonitoring.zrl'),
                            textAlign: "center",
                            fill: "#A6AFB8",
                            width: 30,
                            height: 30,
                            fontSize: this.pieInnerFont,
                            fontFamily: "Microsoft YaHei"
                        }
                    },
                ],
                legend: {
                    orient: "horizontal",
                    bottom: 0,
                    left: "center",
                     icon: "circle",
                    // itemWidth: 10,
                    // itemHeight: 10,
                    data: [
                        {
                            name: this.$t('windPowerGenerationMonitoring.gf'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: this.$t('windPowerGenerationMonitoring.fd'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        }
                    ]
                },
                series: [
                    {
                        name: this.$t('windPowerGenerationMonitoring.zjrl'),
                        type: "pie",
                        radius: ["55%", "75%"],
                        center: ["50%", "40%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: "center"
                        },
                        data: [
                            {
                                value: 335,
                                name: this.$t('windPowerGenerationMonitoring.gf'),
                                itemStyle: {
                                    normal: {
                                        //颜色渐变
                                        color: new echarts.graphic.LinearGradient(
                                            0,
                                            0,
                                            0,
                                            1,
                                            [
                                                { offset: 0, color: "#03F6FE" },
                                                { offset: 1, color: "#0194E4" }
                                            ]
                                        )
                                    }
                                }
                            },
                            {
                                value: 125,
                                name: this.$t('windPowerGenerationMonitoring.fd'),
                                itemStyle: {
                                    color: "#FD980a"
                                }
                            }
                        ]
                    }
                ]
            };
            return option;
        },
        puloxPieDay() {
            const option = {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "horizontal",
                    bottom: 0,
                    left: "center",
                    icon: "circle",
                    data: [
                        {
                            name: this.$t('windPowerGenerationMonitoring.gf'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: this.$t('windPowerGenerationMonitoring.fd'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        }
                    ]
                },
                // title: {
                //     text: "daily power generation",
                //     left: "center",
                //     top: "45%",
                //     textStyle: {
                //         color: "#A6AFB8",
                //         fontSize: this.pieInnerTtitleFont,
                //         align: "center"
                //     }
                // },
                graphic: [
                    {
                        type: "text",
                        left: "center",
                        top: "30%",
                        style: {
                            text: "15889.2kWh",
                            textAlign: "center",
                            fill: "#FD980a",
                            width: 30,
                            height: 30,
                            fontSize: this.pieInnerFont,
                            fontFamily: "Microsoft YaHei"
                        }
                    },
                    {
                        type: "text",
                        left: "center",
                        top: "43%",
                        style: {
                            text: this.$t('windPowerGenerationMonitoring.dailyPowerGeneration'),
                            textAlign: "center",
                            fill: "#A6AFB8",
                            //bounding: 'all',
                            width: 30,
                            height: 30,
                            fontSize: this.pieInnerFont,
                            fontFamily: "Microsoft YaHei"
                        }
                    },
                    // {
                    //     type: "text",
                    //     left: "center",
                    //     top: "48%",
                    //     style: {
                    //         text: "Generation",
                    //         textAlign: "center",
                    //         fill: "#A6AFB8",
                    //         width: 30,
                    //         height: 30,
                    //         fontSize: this.pieInnerFont,
                    //         fontFamily: "Microsoft YaHei"
                    //     }
                    // }
                ],
                series: [
                    {
                        name: this.$t('windPowerGenerationMonitoring.fdl'),
                        type: "pie",
                        radius: ["55%", "75%"],
                        center: ["50%", "40%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: "center"
                        },
                        data: [
                            {
                                value: 335,
                                name: this.$t('windPowerGenerationMonitoring.gf'),
                                itemStyle: {
                                    normal: {
                                        //颜色渐变
                                        color: new echarts.graphic.LinearGradient(
                                            0,
                                            0,
                                            0,
                                            1,
                                            [
                                                { offset: 0, color: "#03F6FE" },
                                                { offset: 1, color: "#0194E4" }
                                            ]
                                        )
                                    }
                                }
                            },
                            {
                                value: 125,
                                name: this.$t('windPowerGenerationMonitoring.fd'),
                                itemStyle: {
                                    color: "#FD980a"
                                }
                            }
                        ]
                    }
                ]
            };
            return option;
        },
        puloxPieMonths() {
            const option = {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "horizontal",
                    bottom: 0,
                    left: "center",
                    icon: "circle",
                    data: [
                        {
                            name: this.$t('windPowerGenerationMonitoring.gf'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: this.$t('windPowerGenerationMonitoring.fd'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        }
                    ]
                },
                // title: {
                //     text: "monthly power generation",
                //     left: "center",
                //     top: "45%",
                //     textStyle: {
                //         color: "#A6AFB8",
                //         fontSize: this.pieInnerTtitleFont,
                //         align: "center"
                //     }
                // },
                graphic: [
                    {
                        type: "text",
                        left: "center",
                        top: "30%",
                        style: {
                            text: "290161.8kWh",
                            textAlign: "center",
                            fill: "#FD980a",
                            width: 30,
                            height: 30,
                            fontSize: this.pieInnerFont,
                            fontFamily: "Microsoft YaHei"
                        }
                    },
                    {
                        type: "text",
                        left: "center",
                        top: "43%",
                        style: {
                            text: this.$t('windPowerGenerationMonitoring.monthlyPowerGeneration'),
                            textAlign: "center",
                            fill: "#A6AFB8",
                            width: 20,
                            height: 30,
                            overflow: 'break',
                            fontSize: this.pieInnerFont,
                            fontFamily: "Microsoft YaHei"
                        }
                    },
                    // {
                    //     type: "text",
                    //     left: "center",
                    //     top: "48%",
                    //     style: {
                    //         text: "Generation",
                    //         textAlign: "center",
                    //         fill: "#A6AFB8",
                    //         width: 30,
                    //         height: 30,
                    //         fontSize: this.pieInnerFont,
                    //         fontFamily: "Microsoft YaHei"
                    //     }
                    // }
                ],
                series: [
                    {
                        name: this.$t('windPowerGenerationMonitoring.fdl'),
                        type: "pie",
                        radius: ["55%", "75%"],
                        center: ["50%", "40%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: "center"
                        },
                        data: [
                            {
                                value: 335,
                                name: this.$t('windPowerGenerationMonitoring.gf'),
                                itemStyle: {
                                    normal: {
                                        //颜色渐变
                                        color: new echarts.graphic.LinearGradient(
                                            0,
                                            0,
                                            0,
                                            1,
                                            [
                                                { offset: 0, color: "#03F6FE" },
                                                { offset: 1, color: "#0194E4" }
                                            ]
                                        )
                                    }
                                }
                            },
                            {
                                value: 125,
                                name: this.$t('windPowerGenerationMonitoring.fd'),
                                itemStyle: {
                                    color: "#FD980a"
                                }
                            }
                        ]
                    }
                ]
            };
            return option;
        },
        puloxPieYear() {
            const option = {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "horizontal",
                    bottom: 0,
                    left: "center",
                    icon: "circle",
                    data: [
                        {
                            name: this.$t('windPowerGenerationMonitoring.gf'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        },
                        {
                            name: this.$t('windPowerGenerationMonitoring.fd'),
                            textStyle: {
                                color: "#fff",
                                fontSize: this.legendFont
                            }
                        }
                    ]
                },
                // title: {
                //     text: "GENERATING ELECTRICITY",
                //     left: "center",
                //     top: "45%",
                //     textStyle: {
                //         color: "#A6AFB8",
                //         fontSize: this.pieInnerTtitleFont,
                //         align: "center"
                //     }
                // },
                graphic: [
                    {
                        type: "text",
                        left: "center",
                        top: "30%",
                        style: {
                            text: "463100.kWh",
                            textAlign: "center",
                            fill: "#FD980a",
                            width: 30,
                            height: 30,
                            fontSize: this.pieInnerFont,
                            fontFamily: "Microsoft YaHei"
                        }
                    },
                    {
                        type: "text",
                        left: "center",
                        top: "43%",
                        style: {
                            text: this.$t('windPowerGenerationMonitoring.fdl'),
                            textAlign: "center",
                            fill: "#A6AFB8",
                            width: 30,
                            height: 30,
                            fontSize: this.pieInnerFont,
                            fontFamily: "Microsoft YaHei"
                        }
                    },
                    // {
                    //     type: "text",
                    //     left: "center",
                    //     top: "48%",
                    //     style: {
                    //         text: "ELECTRICITY",
                    //         textAlign: "center",
                    //         fill: "#A6AFB8",
                    //         width: 30,
                    //         height: 30,
                    //         fontSize: this.pieInnerFont,
                    //         fontFamily: "Microsoft YaHei"
                    //     }
                    // }
                ],
                series: [
                    {
                        name: this.$t('windPowerGenerationMonitoring.fdl'),
                        type: "pie",
                        radius: ["55%", "75%"],
                        center: ["50%", "40%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: "center"
                        },
                        data: [
                            {
                                value: 335,
                                name: this.$t('windPowerGenerationMonitoring.gf'),
                                itemStyle: {
                                    normal: {
                                        //颜色渐变
                                        color: new echarts.graphic.LinearGradient(
                                            0,
                                            0,
                                            0,
                                            1,
                                            [
                                                { offset: 0, color: "#03F6FE" },
                                                { offset: 1, color: "#0194E4" }
                                            ]
                                        )
                                    }
                                }
                            },
                            {
                                value: 125,
                                name: this.$t('windPowerGenerationMonitoring.fd'),
                                itemStyle: {
                                    color: "#FD980a"
                                }
                            }
                        ]
                    }
                ]
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.run-monitor-container {
    width: 100%;
    height: 100%;
    padding: 0 1rem 1rem 1rem;
    box-sizing: border-box;
}
.uxbox {
    width: 100%;
    margin: 0 auto;
    height: 36.5%; //calc((100% - 3rem) / 3);
    .lfdiv {
        width: 50%;
        height: 100%;
        .echarts {
            height: calc(100% - 1.8rem);
            width: 100%;
        }
    }
    ul,
    li {
        height: 100%;
    }
    ul li {
        display: inline-block;
        color: #fff;
        width: 24%;
        background: url("../../../assets/image/leaderpage/kuai1.png") no-repeat
            center right;
        background-size: 100% 100%;
        display: flex;
    }
    .ubx1 {
        float: left;
    }
    .ubx2 {
        float: left;
        margin-left: 1.3%;
    }
    .ubx3 {
        float: left;
        margin-left: 1.3%;
    }
    .ubx4 {
        float: right;
    }
    .nyh2 {
       // text-indent: 2.3rem;
      //  line-height: 1.8rem;
      width: 100%;
      margin-top: 0.4rem;
    }
    .ub_right {
        //padding-top: 0.2rem;
        font-size: 0.9rem;
        flex: 1;
        .grey {
            color: #a6afb8;
        }
        p:first-child {
            margin-top: 52%; //calc((100% - 1.8rem) / 2 - 0.5rem);
        }
        span {
            text-align: right;
            color: #03f6fe;
            font-size: 0.75rem;
            i {
                font-size: 1.2rem;
                font-weight: bold;
                padding: 0 0.2rem;
                font-style: normal;
                color: #fd980a;
            }
        }
    }
}
.nenghao {
    position: relative;
    width: 100%;
    height: 30.5%; //calc((100% - 3rem) / 3);
    margin: 0.5% auto 0 auto;
    background: url(../../../assets/image/leaderpage/monitor_back1.png)
        no-repeat;
    color: #fff;
    background-size: 100% 100%;
    clear: both;
    .boxbox {
        height: 100%;
        .tab_cssl1 {
            width: 96%;
            height: 100%;
            //margin: 1rem auto 0 auto;
            .echarts {
                width: 100%;
                height: calc(100% - 1.8rem);
            }
        }
    }
}
.nyh2 {
    text-align: left;
    font-size: 0.8rem;
    //text-indent: 1.7rem;
    margin-left: 1.7rem;
    line-height: 1rem;
    color: #fff;
    width: 10rem;
}
.goucheng {
    width: 100%;
    height: 30.5%; //calc((100% - 3rem) / 3);
    margin: 0.5% auto 0 auto;
    clear: both;
    position: relative;
    .tab_cssv .echarts {
        width: 100%;
        height: calc(100% - 1.8rem);
    }
    .tab_cssv {
        height: 100%;
    }
    .gou1 {
        background: url(../../../assets/image/leaderpage/monitor_back2.png)
            no-repeat;
        background-size: 100% 100%;
        width: 49%;
        height: 100%;
    }
    .gou2 {
        background: url(../../../assets/image/leaderpage/monitor_back2.png)
            no-repeat;
        background-size: 100% 100%;
        width: 50%;
        height: 100%;
    }
}
@media only screen and (min-width: 1366px) and (max-width: 1680px) {
    .uxbox .ub_right p:first-child {
        margin-top: calc((100% - 1.8rem) / 2 + 0.6rem);
    }
}
</style>
